import {
  IsArray,
  IsNumber,
} from 'class-validator';
import { GiftCardTypeDto } from './giftCardType.dto';

export class GiftCardTypePayloadDto extends GiftCardTypeDto {

  @IsArray()
  @IsNumber({}, { each: true })
  merchants: number[];

}


